import { useState, useEffect } from 'react';
import LavorisService from '../../../services/LavorisService';
import { useSearchParams } from 'react-router-dom';
import { PrimaryButton } from '../../../components/others/ButtonPrimary';
import { Modal, TModalProps } from '../../../components/others/Modal';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    fieldName: string;
    label?: string;
    styles?: string;
};

const Textarea: React.FC<TextareaProps> = ({
    fieldName,
    label,
    styles = "",
    ...rest
}) => {
    return (
        <div className="flex flex-col">
            {label && <label htmlFor={fieldName}>{label}</label>}
            <textarea id={fieldName} name={fieldName} className={styles} {...rest} />
        </div>
    );
};


type UploadFollowUpProps = TModalProps & {
    refreshTable?: () => void;
}



const GetFollowUpMessages = ({
    refreshTable,
    ...props
}: UploadFollowUpProps) => {
    const LavorisInstance = LavorisService.getInstance();
    const [searchParams] = useSearchParams();
    const appointment_id = searchParams.get("rowId") as string;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDeleteLoading, setDeleteIsLoading] = useState<boolean>(false);
    const [hasMore, setHasMore] = useState(true);
    const [messages, setMessages] = useState<any[]>([]);
    const [editState, setEditState] = useState<Record<string, boolean>>({});
    const [editedMessages, setEditedMessages] = useState<Record<string, string>>({});


    const getAllLogs = async () => {
        setHasMore(true);
        try {
            const response = await LavorisInstance.TurnServices.getAppointmentsFollowUp(appointment_id);
            setMessages(response);
            // Inicializa estados de edición
            const initialEditState: Record<string, boolean> = {};
            const initialEditedMessages: Record<string, string> = {};
            response.forEach((msg: any) => {
                initialEditState[msg.id] = false;
                initialEditedMessages[msg.id] = msg.observations || "";
            });
            setEditState(initialEditState);
            setEditedMessages(initialEditedMessages);
        } catch (err) {
            console.log(err);;
        }
    };

    useEffect(() => {
        getAllLogs();

    }, []);

    return (
        <Modal {...props}>
            <div className="w-auto max-h-[40rem]">
                <div className="my-3 w-[1000px]">
                    <div className="flex gap-8 align-middle p-2 border-b bg-slate-300">
                        <div className="w-[500px] m-auto flex justify-start align-middle text-start font-bold">
                            <p className="ml-9">Observación</p>
                        </div>
                        <div className="w-[300px] m-auto flex justify-start align-middle text-start font-bold">
                            <p className="ml-9">Fecha</p>
                        </div>
                        <div className="w-[300px] m-auto flex justify-start align-middle text-start font-bold">
                            <p className="ml-9">Usuario</p>
                        </div>
                        <div className="w-[300px] m-auto flex justify-start align-middle text-start font-bold">
                            <p className="ml-9">Fecha Edición</p>
                        </div>
                        <div className="w-[300px] m-auto flex justify-start align-middle text-start font-bold">
                            <p className="ml-9">Editado por</p>
                        </div>
                    </div>

                    <InfiniteScroll
                        className="border"
                        dataLength={messages.length}
                        next={getAllLogs}
                        hasMore={hasMore}
                        loader={() => { }}
                        height={400}
                    >
                        {messages?.map((message: any) => (
                            <div key={message.id} className="flex gap-8 align-middle p-2 border-b">
                                <div className="w-[500px] m-auto flex justify-start align-middle">
                                    <Textarea
                                        fieldName={`observations-${message.id}`}
                                        label=""
                                        value={editedMessages[message.id] || ""}
                                        disabled={true}
                                        styles="rounded w-full mb-4"
                                        rows={5}
                                    />
                                </div>
                                <div className="w-[250px] m-auto flex justify-start align-middle">
                                    <span className="text-start flex flex-wrap text-sm">
                                        {moment(message.date).format("DD/MM/YYYY HH:mm") || "---"}
                                    </span>
                                </div>
                                <div className="w-[250px] m-auto flex justify-start align-middle">
                                    <span className="text-start flex flex-wrap text-sm">
                                        {message.user?.name || "---"}
                                    </span>
                                </div>
                                <div className="w-[250px] m-auto flex justify-start align-middle">
                                    <span className="text-start flex flex-wrap text-sm">
                                        {message?.update_date ? moment(message?.update_date).format("DD/MM/YYYY HH:mm") : "---"}
                                    </span>
                                </div>
                                <div className="w-[250px] m-auto flex justify-start align-middle">
                                    <span className="text-start flex flex-wrap text-sm">
                                        {message.update_user?.name || "---"}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </InfiniteScroll>
                </div>
                <PrimaryButton
                    type="button"
                    text="Cerrar"
                    onClick={() => props.onClose?.()}
                    styles="w-auto mx-auto my-4 p-5 text-red-500 font-bold"
                />
            </div>
        </Modal>
    );
};

export default GetFollowUpMessages;


